import Icon from "@3gaam/shared/components/general/icon";
import { Space } from "@3gaam/shared/components/general/space";
import React from "react";
import { PromotionProvider as PromotionProviderextJsHall } from "../banner/PromotionProvider";
import { PromotionProvider as PromotionProviderApp } from "@3gaam/app/src/view/components/main/PromotionProvider";

export enum PromotionRenderType {
  None,
  FromApp,
  FromNextJsHall,
};

type Props = {
  children: React.ReactNode;
  onClose: () => void;
  closeIcon?: "cross" | "back";
  title?: string;
  secondaryActionNode?: React.ReactNode;
  secondRowNode?: React.ReactNode;
  className?: string;
  promotionRenderType: PromotionRenderType;
};

const SecondaryLayout = ({
  children,
  closeIcon,
  onClose,
  title,
  secondaryActionNode,
  secondRowNode,
  className,
  promotionRenderType
}: Props) => {

    let PromotionProvider;

    switch (promotionRenderType) {
      case PromotionRenderType.FromApp:
        PromotionProvider = <PromotionProviderApp/>;
        break;
      case PromotionRenderType.FromNextJsHall:
        PromotionProvider = <PromotionProviderextJsHall/>;
        break;
      default:
        PromotionProvider = null;
        break;
    }

  return (
    <>
      {PromotionProvider}
      <div
        className="bg-white d-flex flex-column justify-content-center border-bottom p-3"
        style={{
          height: secondRowNode ? 98 : 56,
        }}
      >
        <div className="d-flex flex-row align-items-center justify-content-between position-relative">
          <div className="d-flex flex-row align-items-center">
            <div
              className="d-flex align-items-center justify-content-center cur-pointer"
              onClick={() => {
                onClose();
              }}
            >
              {closeIcon === "back" ? (
                <Icon name="FA_R-arrow-right" className="font-20 text-gray3 " />
              ) : (
                <Icon name="FA_R-xmark" className="font-18 text-gray3" />
              )}
            </div>
            <Space horizontal={20} />
            <span className="text-gray3 font-18">{title}</span>
          </div>
          {secondaryActionNode}
        </div>
        {secondRowNode}
      </div>
      <div
        className={`${className} ${secondRowNode ? "" : "full-exact-height"}`}
        style={{
          ...(secondRowNode ? { height: "calc(100vh - 98px)" } : {}),
          // overflow: "scroll",
        }}
      >
        {children}
      </div>
    </>
  );
};

export default React.memo(SecondaryLayout);
